var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          staticClass: "contact-form",
          attrs: {
            action: "./resources/contact-form.php",
            method: "POST",
            id: "contactForm",
            novalidate: ""
          },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.ValidateBeforeSubmit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "contact-form__block" }, [
            _c("div", { staticClass: "contact-form__group" }, [
              _c("div", { staticClass: "contact-form__input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "contact-form__input",
                  attrs: {
                    type: "text",
                    name: "name",
                    id: "name",
                    autofocus: "",
                    placeholder: "ex.Ionescu Adrian"
                  },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "contact-form__error" }, [
                  _vm._v(_vm._s(_vm.errors.first("name")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-form__group" }, [
              _c("div", { staticClass: "contact-form__input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.company,
                      expression: "company"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required' "
                    }
                  ],
                  staticClass: "contact-form__input",
                  attrs: {
                    type: "text",
                    name: "company",
                    id: "company",
                    placeholder: "Nume companie optional"
                  },
                  domProps: { value: _vm.company },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.company = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "contact-form__error" }, [
                _vm._v(_vm._s(_vm.errors.first("company")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-form__group" }, [
              _c("div", { staticClass: "contact-form__input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    }
                  ],
                  staticClass: "contact-form__input",
                  attrs: {
                    type: "email",
                    name: "email",
                    id: "email",
                    placeholder: "email"
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "contact-form__error" }, [
                _vm._v(_vm._s(_vm.errors.first("email")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-form__group" }, [
              _c("div", { staticClass: "contact-form__input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|numeric",
                      expression: "'required|numeric'"
                    }
                  ],
                  staticClass: "contact-form__input",
                  attrs: {
                    type: "tel",
                    name: "phone",
                    id: "phone",
                    placeholder: "numar de telefon optional"
                  },
                  domProps: { value: _vm.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "contact-form__error" }, [
                  _vm._v(_vm._s(_vm.errors.first("phone")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.message,
                    expression: "message"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "contact-form__textarea",
                attrs: {
                  name: "message",
                  cols: "40",
                  rows: "10",
                  id: "message",
                  placeholder: "Mesajul trebuie sa contina minim 20 caractere"
                },
                domProps: { value: _vm.message },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.message = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "contact-form__error" }, [
                _vm._v(_vm._s(_vm.errors.first("message")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-form__block" }, [
            _c("div", { staticClass: "button-wrapper text-align--right" }, [
              _c(
                "button",
                {
                  staticClass:
                    "button button--medium button--tertiary button--ghost",
                  attrs: {
                    "aria-label": "trimite",
                    type: "submit",
                    id: "submitBtn"
                  }
                },
                [_vm._v(_vm._s(_vm.btnText))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-form__copy" }, [
            _c("p", [_vm._v("* " + _vm._s(_vm.infoLegal) + " ")])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c("contact-modal", {
            on: {
              close: function($event) {
                _vm.showModal = false
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                _vm.showModal = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e7fdff4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7fdff4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/components/contact-form.vue
// module id = 49
// module chunks = 0